
export const amountOnPageOptions = [
  {value: 25, label: "25",},
  {value: 50, label: "50",},
  {value: 100, label: "100",},
];

export const
    defaultAmountOnPage = 25;